import "./journeysExport.scss";
import { IVeriTableRow, IVeriTableHeader } from "@directives/_veri/veriTable/veriTable.component";
import { VeriDate } from "@services/veriDate.service";
import { SortType } from "@enums/SortType";
import { VeriTableService } from "@directives/_veri/veriTable/veriTable.service";
import { IJourney } from "@interfaces/IJourney";
import { UnitConversionType } from "@services/unitConversion.service";
import { IVehicle } from "@interfaces/IVehicle";
import { TranslationService } from "@services/translation.service";
import { IDateFilter } from "@interfaces/filters/IDateFilter";
import { DateRange } from "@enums/DateRange.enum";

interface IComponentBindings {
    journeys: IJourney[];
    additionalData: IVehicle;
}

class ComponentController implements angular.IComponentController, IComponentBindings {
    tableRows: IVeriTableRow<any>[] = [];
    tableHeaders: IVeriTableHeader[] = [
        { title: this.translationService.t("Common.Driver"), sortType: SortType.String },
        { title: this.translationService.t("journeysExport.startTime"), sortType: SortType.Date },
        { title: this.translationService.t("journeysExport.startLocation"), sortType: SortType.String },
        { title: this.translationService.t("journeysExport.startOdometer"), sortType: SortType.Number },
        { title: this.translationService.t("journeysExport.endTime"), sortType: SortType.Date },
        { title: this.translationService.t("journeysExport.endLocation"), sortType: SortType.String },
        { title: this.translationService.t("journeysExport.endOdometer"), sortType: SortType.Number },
        //{ title: "Duration", sortType: SortType.Number },
        { title: this.translationService.t("journeysExport.averageSpeed"), sortType: SortType.Number },
        //{ title: "Max Speed", sortType: SortType.Number },
        { title: this.translationService.t("Common.Distance"), sortType: SortType.Number },
    ];

    journeys: IJourney[];
    additionalData: IVehicle;

    defaultDateRange: DateRange = DateRange.Today;
    dateFilter: IDateFilter;

    exportTitle = this.translationService.t("Common.Journeys");

    static $inject = ["veriDate", "veriTableService", "translationService"];

    constructor(
        private readonly veriDate: VeriDate,
        private readonly veriTableService: VeriTableService,
        private readonly translationService: TranslationService) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        this.dateFilter = this.veriDate.dateRangeFromEnum(this.defaultDateRange);
        this.updateJourneysTable();

    }

    onDateFilterChanged(filter: IDateFilter): void {
        this.dateFilter = filter;
        this.updateJourneysTable();
    }

    private updateJourneysTable() {

        this.tableRows = [];

        if (this.journeys) {
            this.tableRows = this.createExportDataFromJourneys(this.journeys);
        }

        if (this.additionalData) {
            this.exportTitle = `${this.additionalData.ShortReg} Journeys`;
        } else {
            this.tableHeaders.unshift({ title: this.translationService.t("Common.Vehicle"), sortType: SortType.String });
        }
    }

    private createExportDataFromJourneys(journeys: IJourney[]): IVeriTableRow<any>[] {

        let startTimeMinutes = this.veriDate.parseTimeSpan(this.dateFilter.startTime ?? "00:00:00") / 60;
        let endTimeMinutes = this.veriDate.parseTimeSpan(this.dateFilter.endTime ?? "23:59:59") / 60;

        return this.veriTableService.createTableRowsWithCells(journeys.filter(j => {
            let journeyStartTimeMinutes = this.veriDate.getMinuteOfDayFromDate(this.veriDate.createDate(j.StartUtc));
            let journeyEndTimeMinutes = this.veriDate.getMinuteOfDayFromDate(this.veriDate.createDate(j.EndUtc));
            return (journeyStartTimeMinutes >= startTimeMinutes && journeyStartTimeMinutes <= endTimeMinutes) ||
                (journeyEndTimeMinutes >= startTimeMinutes && journeyEndTimeMinutes <= endTimeMinutes)
        }),
            (journey) => {
                var cells = [
                    { contents: journey.driver ? journey.driver.Name : "" },
                    this.veriTableService.createDateTimeCell(journey.StartUtc),
                    { contents: journey.plots.find(p => p.Id == journey.StartPlotId)?.LocationInformation?.LocationDescription },
                    this.veriTableService.createConvertedValueCell(journey.OdometerKmStart, UnitConversionType.Distance),
                    this.veriTableService.createDateTimeCell(journey.EndUtc),
                    { contents: journey.plots.find(p => p.Id == journey.EndPlotId)?.LocationInformation?.LocationDescription },
                    this.veriTableService.createConvertedValueCell(journey.OdometerKmEnd, UnitConversionType.Distance),
                    //{ contents: journey.duration },
                    this.veriTableService.createConvertedValueCell(journey.AverageSpeed, UnitConversionType.Speed),
                    //this.veriTableService.createConvertedValueCell(journey.MaxSpeedKph, UnitConversionType.Speed),
                    this.veriTableService.createConvertedValueCell(journey.DistanceKm, UnitConversionType.Distance)
                ];

                if (!this.additionalData) {
                    cells.unshift({ contents: journey.vehicle ? journey.vehicle.ShortReg : "" });
                }

                return cells;
            },
            (journey) => {
                const driverName = journey.driver ? journey.driver.Name : "";
                const locationStart = journey.plots.find(p => p.Id == journey.StartPlotId)?.LocationInformation?.LocationDescription;
                const locationEnd = journey.plots.find(p => p.Id == journey.EndPlotId)?.LocationInformation?.LocationDescription;
                const timeStart = this.veriDate.formatDate(journey.StartUtc);
                const timeEnd = this.veriDate.formatDate(journey.EndUtc);

                return `${driverName}${locationStart}${locationEnd}${timeStart}${timeEnd}`;
            });
    }
}

export class JourneysExportComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            journeys: "<",
            additionalData: "<?"
        };

        this.controller = ComponentController;
        this.template = require("./journeysExport.html");
    }
}
